import {
  MilestonePage,
  MilestonePageContent,
} from "@/shared/service-manager/default-ui/milestone-page/milestone-page";
import { CustomersListTable } from "./customer-list-table";

export function CustomersIndexRoute() {
  return (
    <MilestonePage>
      <MilestonePageContent>
        <CustomersListTable />
      </MilestonePageContent>
    </MilestonePage>
  );
}
